import {db} from '../utilities'
import { writeBatch, WriteBatch, DocumentData, doc } from 'firebase/firestore'
import Aggregations from './Aggregations'
import Analytics from './Analytics'
import Authorizations from './Authorizations'
import BaseModel from './BaseModel'
import Calendars from './Calendars'
import CompletedForms from './CompletedForms'
import CSVFilters from './CSVFilters'
import EmailLinks from './EmailLinks'
import FormCSV from './FormCSV'
import FormField from './FormField'
import Forms from './Forms'
import FormSection from './FormSection'
import FormAction from './FormAction'
import Logs from './Logs'
import Meta from './Meta'
import OauthClient from './OauthClient'
import OrganizationAssociations from './OrganizationAssociations'
import Organizations from './Organizations'
import ProjectLocks from './ProjectLocks'
import ProjectLogs from './ProjectLogs'
import Projects from './Projects'
import ProjectThumbnail from './ProjectsThumbnail'
import ProjectSnapshots from './ProjectSnapshots'
import QuestionScores from './QuestionScores'
import Reports from './Reports'
import RollingAverageScores from './RollingAverageScores'
import Rubrics from './Rubrics'
import ScoringSystems from './ScoringSystems'
import Sites from './Sites'
import Subscriptions from './Subscriptions'
import TempProjects from './TempProjects'
import TicketComments from './TicketComments'
import Tickets from './Tickets'
import UserCalendars from './UserCalendars'
import Users from './Users'
import SpecialAccess from './SpecialAccess'; // Import the new SpecialAccess class
import ProjectErrorLogs from './ProjectErrorLogs'
import { project } from '../testingResources'
import { Project } from '../shared_code/Project'

class Batch {
  operations: Promise<any>[]

  constructor() {
    this.operations = []
  }

  add(operation: Promise<any>) {
    this.operations.push(operation)
  }

  async commit() {
    try {
      const results = await Promise.all(this.operations)
      return results
    } catch (e) {
      console.log('batch commit failed: ', e)
      throw e
    }
  }
}

class FirebaseBatch {
  batch: WriteBatch
  constructor() {
    this.batch = writeBatch(db)
  }

  update(baseQuery: BaseModel, id: string, data: DocumentData, merge: boolean = true) {
    const ref = doc(baseQuery.baseQuery, id)
    this.batch.set(ref, data, {merge})
  }

  delete(baseQuery: BaseModel, id: string) {
    const ref = doc(baseQuery.baseQuery, id)
    this.batch.delete(ref)
  }

  async commit() {
    await this.batch.commit()
  }
}

export default {
  Batch,
  FirebaseBatch,
  Analytics,
  Aggregations,
  Meta,
  Projects,
  FormCSV,
  Forms,
  FormSection,
  FormAction,
  FormField,
  Users,
  Calendars,
  Reports,
  ProjectSnapshots,
  Rubrics,
  ScoringSystems,
  Sites,
  Subscriptions,
  ProjectLogs,
  Logs,
  Tickets,
  TicketComments,
  EmailLinks,
  Authorizations,
  Organizations,
  OrganizationAssociations,
  OauthClient,
  CSVFilters,
  QuestionScores,
  RollingAverageScores,
  TempProjects,
  ProjectLocks,
  UserCalendars,
  CompletedForms,
  SpecialAccess, // Add the SpecialAccess to the exports
  ProjectErrorLogs,
  ProjectThumbnail
}

export const dbResources = {
  batch: Batch,
  analytics: Analytics,
  aggregations: Aggregations,
  projects: Projects,
  projectThumbnail: ProjectThumbnail,
  meta: Meta,
  formCSV: FormCSV,
  forms: Forms,
  formSection: FormSection,
  formAction: FormAction,
  formField: FormField,
  users: Users,
  calendars: Calendars,
  reports: Reports,
  snapshots: ProjectSnapshots,
  rolling_average_scores: RollingAverageScores,
  rubrics: Rubrics,
  scoring_systems: ScoringSystems,
  sites: Sites,
  subscriptions: Subscriptions,
  projectTransactionLog: ProjectLogs,
  transactionLog: Logs,
  tickets: Tickets,
  ticketComments: TicketComments,
  emailLinks: EmailLinks,
  authorizations: Authorizations,
  organizations: Organizations,
  oauth2_client: OauthClient,
  csvFilters: CSVFilters,
  tempProjects: TempProjects,
  project_locks: ProjectLocks,
  user_calendars: UserCalendars,
  completed_forms: CompletedForms,
  special_access: SpecialAccess, // Add the SpecialAccess to the resources
  projectErrorLogs: ProjectErrorLogs,
}
